/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_News_UnseenInputs */

const en_us2_community_news_unseen = /** @type {(inputs: Community_News_UnseenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`News you have not seen yet`)
};

const pt_br2_community_news_unseen = /** @type {(inputs: Community_News_UnseenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novidades que você ainda não viu`)
};

const es_419_community_news_unseen = /** @type {(inputs: Community_News_UnseenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novedades que aún no has visto`)
};

const pt_pt2_community_news_unseen = /** @type {(inputs: Community_News_UnseenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novidades que ainda não viste`)
};

const fr_fr2_community_news_unseen = /** @type {(inputs: Community_News_UnseenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveautés que tu n'as pas encore vues`)
};

const de_de2_community_news_unseen = /** @type {(inputs: Community_News_UnseenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuigkeiten, die du noch nicht gesehen hast`)
};

const it_it2_community_news_unseen = /** @type {(inputs: Community_News_UnseenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novità che non hai ancora visto`)
};

/**
* | output |
* | --- |
* | "News you have not seen yet" |
*
* @param {Community_News_UnseenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_news_unseen = /** @type {((inputs?: Community_News_UnseenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_News_UnseenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_news_unseen(inputs)
	if (locale === "es-419") return es_419_community_news_unseen(inputs)
	if (locale === "pt-PT") return pt_pt2_community_news_unseen(inputs)
	if (locale === "fr-FR") return fr_fr2_community_news_unseen(inputs)
	if (locale === "de-DE") return de_de2_community_news_unseen(inputs)
	if (locale === "it-IT") return it_it2_community_news_unseen(inputs)
	return en_us2_community_news_unseen(inputs)
});
export { community_news_unseen as "community.news_unseen" }